import { observable, runInAction } from 'mobx'
import Member from 'iam/models/Member'
import { PrimeMemberByPublicId } from 'iam/MemberStore'
import Job from 'jobs/Job'
import { Id } from 'types/definitions'
import { ignore404 } from 'utils/error-util'
import { CSDeskAPI } from './API'

/**
 * Store for the relationship manager assigned to a job
 */
export default class RelationManagerStore {
  private readonly rmByJobId = observable.map<Id, Member | null>()

  constructor(
    private readonly api: CSDeskAPI,
    private readonly primeMemberByPublicId: PrimeMemberByPublicId,
  ) {}

  /**
   * Get RelationManager assigned to job
   */
  getForJob(jobId: Id): Member | null | undefined {
    return this.rmByJobId.get(jobId)
  }

  /**
   * Fetches the job's RM from csdesk.
   */
  async fetchForJob(job: Job): Promise<Member | null> {
    try {
      const response = await this.api.relationManager
        .getForJob(Id.assert(job.id))
        .catch(ignore404)

      const member = response
        ? this.primeMemberByPublicId({
            workspace_id: job.workspace.id,
            user_public_id: response.data.userPublicId,
          })
        : null

      return runInAction(() => {
        this.rmByJobId.set(job.id, member)
        return member
      })
    } catch (err) {
      console.error(err)
      return null
    }
  }
}
